import React from 'react'
import { useField } from 'formik'
import NumberFormat from 'react-number-format'

function NeoIdentityType({ value, className,placeholder, onChange, tabIndex="", ...props }) {
  const [field] = useField(props)
  return (
    <NumberFormat
      className={className}
      displayType={'input'}
      placeholder={placeholder}
      format='######/##/#'
      mask='_'
      onValueChange={onChange}
      tabIndex={tabIndex}
      {...field}
    />
  )
}

export default React.memo(NeoIdentityType)
